/**
 * Widget Envío Inteligente — Flores de la Plazoleta
 * Motor de lógica de despacho: festivos, días hábiles, próximo despacho, countdown.
 * Geolocalización IP vía /api/geo → fecha estimada de entrega por zona TCC.
 *
 * Shopify Theme App Extension — cargado como script clásico (IIFE, no ES modules).
 * Zona horaria Colombia: UTC-5, sin cambio de horario de verano (America/Bogota).
 *
 * Reglas de despacho (CALC-03):
 *   Días de despacho: Martes (2), Miércoles (3), Viernes (5)
 *   Corte: 10AM del día anterior laboral al despacho
 *     → Martes:   corte el lunes    a las 10AM
 *     → Miércoles: corte el martes  a las 10AM
 *     → Viernes:  corte el jueves   a las 10AM
 *
 * Tránsito TCC por zona (CALC-02):
 *   bogota     → +1 día hábil
 *   principales→ +2 días hábiles
 *   resto      → +3 días hábiles
 */

(function (root) {
  'use strict';

  // ─────────────────────────────────────────────
  // 1. CONSTANTES
  // ─────────────────────────────────────────────

  var GEO_URL = 'https://flores-plazoleta.vercel.app/api/geo';

  // Mapping local de ciudad → zona TCC (duplicado de api/geo.ts para lookup sin llamada al servidor)
  var CITY_ZONE_MAP_CLIENT = {
    'bogota':'bogota','bogotá':'bogota','soacha':'bogota','chia':'bogota',
    'cajica':'bogota','cajicá':'bogota','zipaquira':'bogota','zipaquirá':'bogota',
    'facatativa':'bogota','facatativá':'bogota','madrid':'bogota',
    'mosquera':'bogota','funza':'bogota','la calera':'bogota',
    'tocancipa':'bogota','tocancipá':'bogota','gachancipa':'bogota','gachanciá':'bogota',
    'medellin':'principales','medellín':'principales','cali':'principales',
    'barranquilla':'principales','cartagena':'principales','bucaramanga':'principales',
    'pereira':'principales','manizales':'principales','cucuta':'principales',
    'cúcuta':'principales','ibague':'principales','ibagué':'principales',
    'pasto':'principales','santa marta':'principales','neiva':'principales',
    'villavicencio':'principales','monteria':'principales','montería':'principales',
    'sincelejo':'principales','popayan':'principales','popayán':'principales',
    'armenia':'principales','valledupar':'principales','riohacha':'principales',
    'tunja':'principales','florencia':'principales','quibdo':'principales','quibdó':'principales',
    'yopal':'principales','inirida':'principales','inírida':'principales',
    'mitu':'principales','mitú':'principales','puerto carreño':'principales'
  };

  // Lista de ciudades para el dropdown, agrupada por zona
  var CITIES_BY_ZONE = [
    { zone: 'bogota', label: 'Bogotá y Sabana', cities: ['Bogotá','Chía','Cajicá','Zipaquirá','Facatativá','Madrid','Mosquera','Funza','Soacha','La Calera','Tocancipá'] },
    { zone: 'principales', label: 'Ciudades principales', cities: ['Medellín','Cali','Barranquilla','Cartagena','Bucaramanga','Pereira','Manizales','Cúcuta','Ibagué','Pasto','Santa Marta','Neiva','Villavicencio','Montería','Sincelejo','Popayán','Armenia','Valledupar','Riohacha','Tunja','Florencia','Quibdó','Yopal'] },
    { zone: 'resto', label: 'Resto del país', cities: ['Otra ciudad'] }
  ];

  // 29-sep-2026: Bogotá y Sabana pasa de +1 a 0. Martes, miércoles y viernes son
  // días de ENTREGA en Bogotá, no de despacho (Paola, 28 y 29-sep; y el ejemplo de la
  // ficha: pedido el miércoles después de las 10AM, llega el viernes). Con +1 el aviso
  // prometía llegadas en jueves y lunes. El resto del país sigue igual.
  // Ojo: 0 es falsy, por eso las lecturas usan != null y no '|| 1'.
  var ZONE_TRANSIT_DAYS = { bogota: 0, principales: 2, resto: 3 };

  // Despachos fijos para productos especiales (ej. Corazón de Mamá — Día de la Madre 2026)
  // Bogotá/Sabana: Envío Express mensajería directa → entrega al día siguiente
  // Otras zonas: TCC normal desde fecha de despacho
  var FIXED_DISPATCH_MAP = {
    'mayo7': {
      // Jueves 7 de mayo 2026 — despacho único para Corazón de Mamá
      dispatchUTC: new Date(Date.UTC(2026, 4, 7, 17, 0, 0)),  // mediodía Colombia
      cutoffUTC:   new Date(Date.UTC(2026, 4, 7, 15, 0, 0)),  // 10AM Colombia = cierre preventa
      dispatchLabel: 'jueves 7 de mayo',
      deliveryBogotaLabel: 'viernes 8 de mayo'                // Envío Express D+1
    }
  };

  var _fixedDispatchConfig = null;

  // Campañas con fecha de cierre (ej. Amor y Amistad 2026 — stock limitado).
  // El widget sigue la lógica normal de despachos, pero:
  //   · acepta días de despacho extra (corte el día anterior a las 10AM)
  //   · después del último despacho muestra "pedidos cerrados" en vez de la siguiente fecha
  // Se activa con data-campaign-key en el <div id="widget-envio"> (ver snippet widget-envio.liquid).
  var CAMPAIGN_MAP = {
    'aya17': {
      lastDispatchKey: '2026-09-17',        // jueves 17 de septiembre (Colombia)
      extraDispatchDays: ['2026-09-17'],    // el jueves no es día normal de despacho
      closedTitle: 'Pedidos de Amor y Amistad cerrados',
      closedSubtitle: 'El último despacho de este bouquet fue el jueves 17 de septiembre'
    }
  };

  var _campaignConfig = null;

  // Clave 'YYYY-MM-DD' de un Date interpretado como fecha local (Colombia)
  function localDateKey(d) {
    return d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0');
  }

  var FESTIVOS_2026 = [
    '2026-01-01', // Año Nuevo
    '2026-01-12', // Reyes Magos (lunes siguiente al 6 ene)
    '2026-03-23', // San José (lunes siguiente al 19 mar)
    '2026-04-02', // Jueves Santo
    '2026-04-03', // Viernes Santo
    '2026-05-01', // Día del Trabajo
    '2026-05-18', // Ascensión del Señor (lunes siguiente)
    '2026-06-08', // Corpus Christi (lunes siguiente)
    '2026-06-15', // Sagrado Corazón (lunes siguiente)
    '2026-06-29', // San Pedro y San Pablo
    '2026-07-20', // Independencia de Colombia
    '2026-08-07', // Batalla de Boyacá
    '2026-08-17', // Asunción de la Virgen (lunes siguiente al 15 ago)
    '2026-10-12', // Día de la Raza (lunes siguiente)
    '2026-11-02', // Todos los Santos (lunes siguiente)
    '2026-11-16', // Independencia de Cartagena (lunes siguiente)
    '2026-12-08', // Inmaculada Concepción
    '2026-12-25'  // Navidad
  ];

  var DIAS_ES = ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'];
  var MESES_ES = ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio',
                  'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'];

  // ─────────────────────────────────────────────
  // 2. normalizeCity(s) → string
  // Normaliza un nombre de ciudad para lookup en CITY_ZONE_MAP_CLIENT:
  // lowercase + eliminar tildes.
  // ─────────────────────────────────────────────
  function normalizeCity(s) {
    return s.toLowerCase()
      .replace(/á/g,'a').replace(/é/g,'e').replace(/í/g,'i')
      .replace(/ó/g,'o').replace(/ú/g,'u').replace(/ü/g,'u');
  }

  // ─────────────────────────────────────────────
  // 3. getCityZone(cityName) → 'bogota'|'principales'|'resto'
  // Lookup local en CITY_ZONE_MAP_CLIENT sin llamada al servidor.
  // ─────────────────────────────────────────────
  function getCityZone(cityName) {
    if (!cityName) return 'bogota';
    var key = normalizeCity(cityName);
    return CITY_ZONE_MAP_CLIENT[key] || 'resto';
  }

  // ─────────────────────────────────────────────
  // (isHoliday original — ahora sección 4)
  // ─────────────────────────────────────────────

  // ─────────────────────────────────────────────
  // 4. isHoliday(date) → boolean
  // Compara la fecha UTC del objeto Date con la lista de festivos.
  // Los festivos están en hora Colombia (UTC-5); para comparar correctamente
  // usamos la fecha Colombia del objeto (restando 5h).
  // ─────────────────────────────────────────────
  function isHoliday(date) {
    // Obtener fecha en Colombia: restar 5h al UTC
    var colombiaMs = date.getTime() - (5 * 60 * 60 * 1000);
    var colombiaDate = new Date(colombiaMs);
    var y = colombiaDate.getUTCFullYear();
    var m = String(colombiaDate.getUTCMonth() + 1).padStart(2, '0');
    var d = String(colombiaDate.getUTCDate()).padStart(2, '0');
    var key = y + '-' + m + '-' + d;
    return FESTIVOS_2026.indexOf(key) !== -1;
  }

  // ─────────────────────────────────────────────
  // 3. isWorkingDay(date) → boolean
  // true si el día (en Colombia) no es fin de semana ni festivo.
  //
  // Es el calendario de OPERACIÓN DE FLORES, no el del transportador: lo usa
  // findNextDispatch() para validar que el día de despacho y el día de corte caigan
  // en un día en que Flores sí despacha/recibe. El sábado quedó excluido aquí el
  // 11-sep-2026 porque Flores no despacha, no recibe ni opera los sábados.
  //
  // No usar esta función para calcular la fecha de ENTREGA (eso es isTransitDay,
  // justo abajo): TCC sí reparte los sábados, así que para el tránsito el sábado
  // cuenta. Mezclar las dos calculaba "72 horas" como si fueran casi una semana
  // cada vez que el tránsito cruzaba un sábado (corregido 8-oct-2026, a pedido de
  // Alejandra Díaz — devoluciones del cliente: "las entregas son 72 horas después
  // para el resto del país, no una semana").
  // ─────────────────────────────────────────────
  function isWorkingDay(date) {
    // Obtener día de la semana en Colombia
    var colombiaMs = date.getTime() - (5 * 60 * 60 * 1000);
    var colombiaDate = new Date(colombiaMs);
    var dow = colombiaDate.getUTCDay(); // 0=dom, 1=lun, ..., 6=sáb
    if (dow === 0) return false; // domingo
    if (dow === 6) return false; // sábado: Flores no opera, pero TCC sí reparte (ver isTransitDay)
    if (isHoliday(date)) return false;
    return true;
  }

  // ─────────────────────────────────────────────
  // 3b. isTransitDay(date) → boolean
  // true si el día cuenta para el TRÁNSITO del pedido (TCC), que es distinto del
  // calendario de operación de Flores: excluye domingo y festivos, pero el
  // sábado SÍ cuenta (TCC entrega sábados). La usa addWorkingDays() para calcular
  // la fecha de llegada; isWorkingDay() sigue siendo la que valida despacho/corte.
  // ─────────────────────────────────────────────
  function isTransitDay(date) {
    var colombiaMs = date.getTime() - (5 * 60 * 60 * 1000);
    var colombiaDate = new Date(colombiaMs);
    var dow = colombiaDate.getUTCDay(); // 0=dom, 1=lun, ..., 6=sáb
    if (dow === 0) return false; // domingo
    if (isHoliday(date)) return false;
    return true;
  }

  // ─────────────────────────────────────────────
  // 4. getColombiaTime() → Date
  // Retorna un Date cuyo getUTC* refleja la hora local de Colombia.
  // ─────────────────────────────────────────────
  function getColombiaTime() {
    // Usa toLocaleString para obtener la hora local Colombia
    var now = new Date();
    var localStr = now.toLocaleString('en-US', { timeZone: 'America/Bogota' });
    return new Date(localStr);
  }

  // ─────────────────────────────────────────────
  // 5. formatDateES(date) → string
  // Formatea una fecha UTC en español colombiano sin Intl.DateTimeFormat.
  // Usa UTC-5 para convertir a hora Colombia antes de formatear.
  // ─────────────────────────────────────────────
  function formatDateES(date) {
    // Convertir UTC → Colombia (-5h)
    var colombiaMs = date.getTime() - (5 * 60 * 60 * 1000);
    var col = new Date(colombiaMs);
    return DIAS_ES[col.getUTCDay()] + ' ' + col.getUTCDate() + ' de ' + MESES_ES[col.getUTCMonth()];
  }

  // ─────────────────────────────────────────────
  // 6. addWorkingDays(fromDate, days) → Date
  // Clona fromDate (no muta) e itera sumando días de TRÁNSITO (isTransitDay, no
  // isWorkingDay: el sábado sí cuenta, ver nota del 8-oct-2026 arriba).
  // Retorna la fecha cuando haya acumulado `days` días de tránsito.
  // fromDate: Date UTC (ej. dispatchDate)
  // ─────────────────────────────────────────────
  function addWorkingDays(fromDate, days) {
    var result = new Date(fromDate.getTime()); // clonar
    var accumulated = 0;
    while (accumulated < days) {
      result = new Date(result.getTime() + 24 * 60 * 60 * 1000); // +1 día de calendario
      if (isTransitDay(result)) {
        accumulated++;
      }
    }
    return result;
  }

  // ─────────────────────────────────────────────
  // 7. Configuración de despacho
  // Cada entrada: { dispatchDow: número del día de despacho, cutoffDow: número del día de corte }
  // ─────────────────────────────────────────────
  var DISPATCH_CONFIG = [
    { dispatchDow: 2, cutoffDow: 1 }, // Martes → corte lunes
    { dispatchDow: 3, cutoffDow: 2 }, // Miércoles → corte martes
    { dispatchDow: 5, cutoffDow: 4 }  // Viernes → corte jueves
  ];

  // ─────────────────────────────────────────────
  // 8. makeDateAtHour(date, hour) → Date (UTC)
  // Dado un Date (interpretado como Colombia local), devuelve un Date UTC
  // equivalente a ese mismo día Colombia a las `hour` horas.
  // ─────────────────────────────────────────────
  function makeDateAtHour(date, hour) {
    // date.getFullYear/Month/Date son de Colombia local (ver getColombiaTime)
    // Construir UTC: Colombia = UTC-5, entonces UTC = Colombia + 5h
    return new Date(Date.UTC(
      date.getFullYear(),
      date.getMonth(),
      date.getDate(),
      hour + 5, // Colombia hora → UTC
      0, 0, 0
    ));
  }

  // ─────────────────────────────────────────────
  // 9. findNextDispatch(now) → { dispatchDate, cutoffDate, isOpen }
  // now: Date en hora Colombia (como retorna getColombiaTime).
  // Itera hasta 14 días adelante buscando el próximo despacho cuyo corte
  // aún no ha pasado. Retorna:
  //   dispatchDate: Date UTC del día de despacho
  //   cutoffDate: Date UTC del momento de corte (día anterior a las 10AM Colombia)
  //   isOpen: boolean — true si now < cutoffDate
  // ─────────────────────────────────────────────
  function findNextDispatch(now) {
    // Iterar por días hacia adelante (máx 14 días)
    for (var offset = 0; offset <= 14; offset++) {
      // Construir candidato (Colombia local date, desplazado 'offset' días desde now)
      var candidateCol = new Date(
        now.getFullYear(),
        now.getMonth(),
        now.getDate() + offset,
        12, 0, 0 // mediodía para evitar problemas DST
      );
      var dow = candidateCol.getDay(); // 0=dom..6=sáb

      // Campaña con cierre: pasado el último día de despacho, no hay más fechas
      var candKey = localDateKey(candidateCol);
      var configs = DISPATCH_CONFIG;
      if (_campaignConfig) {
        if (candKey > _campaignConfig.lastDispatchKey) {
          return { closed: true, dispatchDate: null, cutoffDate: null, isOpen: false };
        }
        if (_campaignConfig.extraDispatchDays.indexOf(candKey) !== -1) {
          configs = DISPATCH_CONFIG.concat([{ dispatchDow: dow, cutoffDow: (dow + 6) % 7 }]);
        }
      }

      // Buscar si este día es un día de despacho
      for (var i = 0; i < configs.length; i++) {
        var cfg = configs[i];
        if (cfg.dispatchDow !== dow) continue;

        // Es un día de despacho. Verificar que sea día laboral.
        var dispatchUTC = makeDateAtHour(candidateCol, 12); // UTC equivalent
        if (!isWorkingDay(dispatchUTC)) continue;

        // Calcular el día de corte (día anterior de la semana de corte)
        // La diferencia de días entre despacho y corte:
        // - Martes(2) → Lunes(1): diferencia -1
        // - Miércoles(3) → Martes(2): diferencia -1
        // - Viernes(5) → Jueves(4): diferencia -1
        // Siempre es -1 día en nuestros casos, PERO hay que verificar que
        // el día de corte sea laboral. Si no lo es, este despacho no aplica.
        var cutoffCandidateCol = new Date(
          candidateCol.getFullYear(),
          candidateCol.getMonth(),
          candidateCol.getDate() - 1,
          12, 0, 0
        );

        // Verificar que el día de corte sea el día esperado y sea laboral
        if (cutoffCandidateCol.getDay() !== cfg.cutoffDow) continue;
        var cutoffUTCCheck = makeDateAtHour(cutoffCandidateCol, 12);
        if (!isWorkingDay(cutoffUTCCheck)) continue;

        // Construir cutoffDate: ese día Colombia a las 10:00 AM → en UTC
        var cutoffDate = makeDateAtHour(cutoffCandidateCol, 10);

        // Construir dispatchDate: día de despacho Colombia mediodía → en UTC
        var dispatchDate = makeDateAtHour(candidateCol, 12);

        // now es Colombia local (local Date object), cutoffDate es UTC.
        // Comparar usando timestamps:
        // Convertir 'now' (Colombia local Date) al timestamp equivalente.
        // now fue creado con new Date(localStr) → sus getFullYear/Month/Date/Hours
        // ya son Colombia. Convertir a UTC timestamp: Colombia = UTC-5.
        var nowUTC = new Date(Date.UTC(
          now.getFullYear(),
          now.getMonth(),
          now.getDate(),
          now.getHours() + 5,
          now.getMinutes(),
          now.getSeconds()
        ));

        // Si el corte ya pasó → ventana cerrada, seguir buscando
        if (nowUTC.getTime() >= cutoffDate.getTime()) {
          // Ventana cerrada para este despacho, continuar al siguiente
          continue;
        }

        // Ventana abierta → este es el próximo despacho válido
        return {
          dispatchDate: dispatchDate,
          cutoffDate: cutoffDate,
          isOpen: true
        };
      }
    }

    // Fallback: no se encontró ningún despacho (no debería ocurrir en condiciones normales)
    return null;
  }

  // ─────────────────────────────────────────────
  // 10. Helpers de formato de fecha en español
  // ─────────────────────────────────────────────
  function formatDispatchDate(dispatchDate) {
    // dispatchDate es UTC. Obtener Colombia local (-5h):
    var colombiaMs = dispatchDate.getTime() - (5 * 60 * 60 * 1000);
    var col = new Date(colombiaMs);
    var dow = DIAS_ES[col.getUTCDay()];
    var day = col.getUTCDate();
    var month = MESES_ES[col.getUTCMonth()];
    return dow + ' ' + day + ' de ' + month;
  }

  function formatCountdown(msLeft) {
    if (msLeft <= 0) return '00h 00m 00s';
    var totalSecs = Math.floor(msLeft / 1000);
    var h = Math.floor(totalSecs / 3600);
    var m = Math.floor((totalSecs % 3600) / 60);
    var s = totalSecs % 60;
    return String(h).padStart(2, '0') + 'h ' +
           String(m).padStart(2, '0') + 'm ' +
           String(s).padStart(2, '0') + 's';
  }

  // ─────────────────────────────────────────────
  // 11. getDispatchLabel(dispatchDate, cutoffDate, now)
  // → { titulo, subtitulo, countdown }
  // now: Colombia local Date (de getColombiaTime)
  // ─────────────────────────────────────────────
  function getDispatchLabel(dispatchDate, cutoffDate, now) {
    // Convertir now a UTC timestamp para comparación consistente
    var nowUTC = new Date(Date.UTC(
      now.getFullYear(),
      now.getMonth(),
      now.getDate(),
      now.getHours() + 5,
      now.getMinutes(),
      now.getSeconds()
    ));

    var msLeft = cutoffDate.getTime() - nowUTC.getTime();

    if (msLeft > 0) {
      // Ventana abierta
      var countdown = formatCountdown(msLeft);
      var dispatchLabel = formatDispatchDate(dispatchDate);

      // Determinar si el despacho es hoy en Colombia
      var colombiaDispatchMs = dispatchDate.getTime() - (5 * 60 * 60 * 1000);
      var colDispatch = new Date(colombiaDispatchMs);

      // Determinar cuándo es el cutoff en Colombia
      var cutoffColMs = cutoffDate.getTime() - (5 * 60 * 60 * 1000);
      var colCutoff = new Date(cutoffColMs);
      var cutoffIsToday = (colCutoff.getUTCDate() === now.getDate() &&
                           colCutoff.getUTCMonth() === now.getMonth() &&
                           colCutoff.getUTCFullYear() === now.getFullYear());
      var tomorrowCol = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1);
      var cutoffIsTomorrow = (colCutoff.getUTCDate() === tomorrowCol.getDate() &&
                              colCutoff.getUTCMonth() === tomorrowCol.getMonth() &&
                              colCutoff.getUTCFullYear() === tomorrowCol.getFullYear());

      var titulo;
      if (colDispatch.getUTCDate() === now.getDate() &&
          colDispatch.getUTCMonth() === now.getMonth() &&
          colDispatch.getUTCFullYear() === now.getFullYear()) {
        titulo = 'Pide antes de las 10AM — despacho HOY';
      } else if (cutoffIsToday) {
        titulo = 'Pide antes de las 10AM de hoy';
      } else if (cutoffIsTomorrow) {
        titulo = 'Pide antes de las 10AM de mañana';
      } else {
        var cutoffLabel = formatDispatchDate(cutoffDate);
        titulo = 'Pide antes de las 10AM del ' + cutoffLabel;
      }

      return {
        titulo: titulo,
        subtitulo: null, // ciudad + entrega se agregan en renderWidget vía geo
        countdown: countdown
      };
    } else {
      // Ventana cerrada
      var nextLabel = formatDispatchDate(dispatchDate);
      return {
        titulo: 'El próximo despacho es el ' + nextLabel,
        subtitulo: null,
        countdown: null
      };
    }
  }

  // ─────────────────────────────────────────────
  // 12. renderWidget(label, city, delivery)
  // Actualiza el DOM con los datos de despacho y entrega.
  //   label: objeto { titulo, subtitulo, countdown } de getDispatchLabel
  //   city: string | null — ciudad detectada por geo (ej. "Bogotá")
  //   delivery: string | null — texto de entrega (ej. "Llega el martes 7 de abril")
  // ─────────────────────────────────────────────
  function renderWidget(label, city, delivery) {
    var el = document.getElementById('widget-envio');
    if (!el) return;

    el.classList.remove('widget-envio--loading');

    var titulo = document.getElementById('widget-envio__titulo');
    var subtitulo = document.getElementById('widget-envio__subtitulo');
    var countdown = document.getElementById('widget-envio__countdown');

    if (titulo) titulo.textContent = label.titulo || '';

    if (subtitulo) {
      if (city && delivery) {
        subtitulo.textContent = city + ' · ' + delivery;
      } else if (delivery) {
        subtitulo.textContent = delivery;
      } else {
        subtitulo.textContent = '';
      }
    }

    if (countdown) {
      countdown.textContent = label.countdown ? 'Faltan ' + label.countdown + ' para el siguiente corte' : '';
    }
  }

  // ─────────────────────────────────────────────
  // 12b. renderClosed(city) — campaña cerrada: sin fecha ni countdown
  // ─────────────────────────────────────────────
  function renderClosed(city) {
    var cfg = _campaignConfig || {};
    var label = { titulo: cfg.closedTitle || 'Pedidos cerrados', subtitulo: null, countdown: null };
    renderWidget(label, city || null, cfg.closedSubtitle || null);
    var el = document.getElementById('widget-envio');
    if (el) el.classList.add('widget-envio--closed');
  }

  // ─────────────────────────────────────────────
  // 13. onCityChange(selectedCity) — handler de selección manual de ciudad
  // Recalcula la fecha de entrega localmente usando CITY_ZONE_MAP_CLIENT
  // (sin llamada al servidor) y actualiza el DOM. Persiste en localStorage.
  // ─────────────────────────────────────────────
  function onCityChange(selectedCity) {
    var zone = getCityZone(selectedCity);
    var now = getColombiaTime();
    try { localStorage.setItem('fdlp_ciudad', selectedCity); } catch(e) {}

    if (_fixedDispatchConfig) {
      var cfg = _fixedDispatchConfig;
      var nowUTC = new Date(Date.UTC(
        now.getFullYear(), now.getMonth(), now.getDate(),
        now.getHours() + 5, now.getMinutes(), now.getSeconds()
      ));
      var msLeft = cfg.cutoffUTC.getTime() - nowUTC.getTime();
      var titulo = msLeft > 0
        ? 'Preventa · Despacho único el ' + cfg.dispatchLabel
        : 'Despacho el ' + cfg.dispatchLabel + ' · Preventa cerrada';
      var label = { titulo: titulo, subtitulo: null, countdown: msLeft > 0 ? formatCountdown(msLeft) : null };
      renderWidget(label, selectedCity, getFixedDelivery(cfg, zone));
      return;
    }

    var transitDays = (ZONE_TRANSIT_DAYS[zone] != null ? ZONE_TRANSIT_DAYS[zone] : 1);
    var dispatch = findNextDispatch(now);
    if (!dispatch) return;
    if (dispatch.closed) { renderClosed(selectedCity); return; }
    var label = getDispatchLabel(dispatch.dispatchDate, dispatch.cutoffDate, now);
    var deliveryDate = addWorkingDays(dispatch.dispatchDate, transitDays);
    renderWidget(label, selectedCity, 'Llega el ' + formatDateES(deliveryDate));
  }

  // ─────────────────────────────────────────────
  // 14. initDropdown() — conecta el select del DOM al handler onCityChange
  // ─────────────────────────────────────────────
  function initDropdown() {
    var select = document.getElementById('widget-envio__select');
    if (!select) return;
    select.addEventListener('change', function() {
      if (select.value) onCityChange(select.value);
    });
  }

  // ─────────────────────────────────────────────
  // 14b. positionWidget() — mueve el widget al DOM correcto (después del botón de compra)
  // Se ejecuta antes de poblar el contenido para evitar un flash en posición incorrecta.
  // ─────────────────────────────────────────────
  function positionWidget() {
    var widget = document.getElementById('widget-envio');
    if (!widget) return;
    // Selectores del botón/formulario de compra en orden de especificidad (Horizon theme).
    // 22-sep-2026: cuando el producto está agotado, el bloque de pago rápido
    // (.accelerated-checkout-block) sigue en el DOM pero con display:none, y
    // document.querySelector puede devolver ese anchor oculto. Se agrega
    // 'button[name="add"]' (el botón real de compra/agotado, siempre visible) como
    // primera opción, y se revisa offsetParent !== null en cada candidato para
    // descartar anclas ocultas antes de anclarse a ellas.
    var targets = [
      'button[name="add"]',
      '[data-testid="buy-buttons"]',
      '.shopify-payment-button',
      '.product-form__buttons',
      'form[action="/cart/add"]',
      '.product-form',
      '[data-product-form]'
    ];
    for (var i = 0; i < targets.length; i++) {
      var candidatos = document.querySelectorAll(targets[i]);
      for (var j = 0; j < candidatos.length; j++) {
        if (candidatos[j].offsetParent !== null) {
          candidatos[j].insertAdjacentElement('afterend', widget);
          return;
        }
      }
    }
  }

  // ─────────────────────────────────────────────
  // 14c. getFixedDelivery(cfg, zone) → string
  // Retorna el texto "Llega el …" para despacho fijo según zona TCC.
  // Bogotá usa Envío Express (fecha fija), otras zonas calculan días hábiles desde dispatchUTC.
  // ─────────────────────────────────────────────
  function getFixedDelivery(cfg, zone) {
    if (zone === 'bogota') return 'Envío Express · Llega el ' + cfg.deliveryBogotaLabel;
    var transitDays = (ZONE_TRANSIT_DAYS[zone] != null ? ZONE_TRANSIT_DAYS[zone] : 1);
    var deliveryDate = addWorkingDays(cfg.dispatchUTC, transitDays);
    return 'Llega el ' + formatDateES(deliveryDate);
  }

  // ─────────────────────────────────────────────
  // 14d. initFixedWidget(cfg) — widget para productos con despacho fijo
  // Muestra fecha de despacho fija + countdown al cierre de preventa.
  // ─────────────────────────────────────────────
  function initFixedWidget(cfg) {
    positionWidget();
    var now = getColombiaTime();
    var nowUTC = new Date(Date.UTC(
      now.getFullYear(), now.getMonth(), now.getDate(),
      now.getHours() + 5, now.getMinutes(), now.getSeconds()
    ));

    var msLeft = cfg.cutoffUTC.getTime() - nowUTC.getTime();
    var countdown = msLeft > 0 ? formatCountdown(msLeft) : null;

    var titulo = msLeft > 0
      ? 'Preventa · Despacho único el ' + cfg.dispatchLabel
      : 'Despacho el ' + cfg.dispatchLabel + ' · Preventa cerrada';

    var label = { titulo: titulo, subtitulo: null, countdown: countdown };
    renderWidget(label, null, null);

    fetch(GEO_URL)
      .then(function(r) { return r.json(); })
      .then(function(geo) {
        var delivery = getFixedDelivery(cfg, geo.zone);
        renderWidget(label, geo.city || null, delivery);
      })
      .catch(function() {
        renderWidget(label, null, getFixedDelivery(cfg, 'bogota'));
      })
      .then(function() {
        var savedCity = null;
        try { savedCity = localStorage.getItem('fdlp_ciudad'); } catch(e) {}
        if (savedCity) {
          var zone = getCityZone(savedCity);
          renderWidget(label, savedCity, getFixedDelivery(cfg, zone));
        }
      });

    initDropdown();

    if (countdown) {
      if (_countdownInterval) { clearInterval(_countdownInterval); _countdownInterval = null; }
      _countdownInterval = setInterval(function() {
        var n = getColombiaTime();
        var nUTC = new Date(Date.UTC(
          n.getFullYear(), n.getMonth(), n.getDate(),
          n.getHours() + 5, n.getMinutes(), n.getSeconds()
        ));
        var ms = cfg.cutoffUTC.getTime() - nUTC.getTime();
        var cntEl = document.getElementById('widget-envio__countdown');
        if (cntEl) {
          cntEl.textContent = ms > 0 ? 'Faltan ' + formatCountdown(ms) + ' para cerrar la preventa' : '';
        }
        if (ms <= 0) { clearInterval(_countdownInterval); _countdownInterval = null; }
      }, 1000);
    }
  }

  // ─────────────────────────────────────────────
  // 15. initWidget() — función principal
  // Calcula despacho, hace render inicial, llama /api/geo para ciudad y
  // fecha estimada de entrega, e inicia countdown si aplica.
  // ─────────────────────────────────────────────
  var _countdownInterval = null;

  function initWidget() {
    var el = document.getElementById('widget-envio');
    var fixedKey = el ? el.getAttribute('data-fixed-key') : null;
    if (fixedKey && FIXED_DISPATCH_MAP[fixedKey]) {
      _fixedDispatchConfig = FIXED_DISPATCH_MAP[fixedKey];
      initFixedWidget(_fixedDispatchConfig);
      return;
    }
    _fixedDispatchConfig = null;
    var campaignKey = el ? el.getAttribute('data-campaign-key') : null;
    _campaignConfig = (campaignKey && CAMPAIGN_MAP[campaignKey]) ? CAMPAIGN_MAP[campaignKey] : null;

    positionWidget();
    var now = getColombiaTime();
    var dispatch = findNextDispatch(now);

    if (dispatch && dispatch.closed) {
      renderClosed(null);
      return;
    }

    if (!dispatch) {
      var el = document.getElementById('widget-envio');
      if (el) {
        el.classList.remove('widget-envio--loading');
        var titulo = document.getElementById('widget-envio__titulo');
        if (titulo) titulo.textContent = 'Consultar disponibilidad de envío';
      }
      return;
    }

    var label = getDispatchLabel(dispatch.dispatchDate, dispatch.cutoffDate, now);

    // Render inicial con datos de despacho (sin ciudad aún — geo en vuelo)
    renderWidget(label, null, null);

    // Llamar geo en paralelo para obtener ciudad y fecha estimada de entrega
    fetch(GEO_URL)
      .then(function (r) { return r.json(); })
      .then(function (geo) {
        var transitDays = (ZONE_TRANSIT_DAYS[geo.zone] != null ? ZONE_TRANSIT_DAYS[geo.zone] : 1);
        var deliveryDate = addWorkingDays(dispatch.dispatchDate, transitDays);
        var cityLabel = geo.city || 'Tu ciudad';
        var deliveryLabel = 'Llega el ' + formatDateES(deliveryDate);
        renderWidget(label, cityLabel, deliveryLabel);
      })
      .catch(function () {
        // Fallback: mostrar sin ciudad, zona bogota (+1 día hábil) por defecto
        var deliveryDate = addWorkingDays(dispatch.dispatchDate, ZONE_TRANSIT_DAYS.bogota);
        renderWidget(label, null, 'Llega el ' + formatDateES(deliveryDate));
      })
      .then(function () {
        // Después del geo (ok o fallback), revisar si hay ciudad guardada en localStorage.
        // Si la hay, aplicarla (sobreescribe el resultado del geo).
        var savedCity = null;
        try { savedCity = localStorage.getItem('fdlp_ciudad'); } catch(e) {}
        if (savedCity) { onCityChange(savedCity); }
      });

    // Iniciar el dropdown de corrección de ciudad
    initDropdown();

    // Iniciar countdown si la ventana de despacho está abierta
    if (dispatch.isOpen && label.countdown) {
      if (_countdownInterval) {
        clearInterval(_countdownInterval);
        _countdownInterval = null;
      }
      _countdownInterval = setInterval(function () {
        var n = getColombiaTime();
        var d = findNextDispatch(n);
        if (!d) {
          clearInterval(_countdownInterval);
          _countdownInterval = null;
          return;
        }
        if (d.closed) {
          clearInterval(_countdownInterval);
          _countdownInterval = null;
          initWidget();
          return;
        }
        var l = getDispatchLabel(d.dispatchDate, d.cutoffDate, n);
        var countdown = document.getElementById('widget-envio__countdown');
        if (countdown) {
          countdown.textContent = l.countdown ? 'Faltan ' + l.countdown + ' para el siguiente corte' : '';
        }
        // Cuando el countdown llega a cero, re-inicializar el widget completo
        if (!l.countdown) {
          clearInterval(_countdownInterval);
          _countdownInterval = null;
          initWidget();
        }
      }, 1000);
    }
  }

  // ─────────────────────────────────────────────
  // 14. Auto-init cuando el DOM esté listo
  // ─────────────────────────────────────────────
  if (typeof document !== 'undefined') {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initWidget);
    } else {
      initWidget();
    }
  }

  // ─────────────────────────────────────────────
  // 15. Exponer funciones para testing (y debugging en consola)
  // ─────────────────────────────────────────────
  root._widgetEnvio = {
    isHoliday: isHoliday,
    isWorkingDay: isWorkingDay,
    isTransitDay: isTransitDay,
    findNextDispatch: findNextDispatch,
    getDispatchLabel: getDispatchLabel,
    getColombiaTime: getColombiaTime,
    addWorkingDays: addWorkingDays,
    formatDateES: formatDateES,
    renderWidget: renderWidget,
    initWidget: initWidget,
    normalizeCity: normalizeCity,
    getCityZone: getCityZone,
    onCityChange: onCityChange,
    initDropdown: initDropdown,
    FESTIVOS_2026: FESTIVOS_2026,
    GEO_URL: GEO_URL,
    ZONE_TRANSIT_DAYS: ZONE_TRANSIT_DAYS,
    CITY_ZONE_MAP_CLIENT: CITY_ZONE_MAP_CLIENT,
    CITIES_BY_ZONE: CITIES_BY_ZONE,
    FIXED_DISPATCH_MAP: FIXED_DISPATCH_MAP,
    CAMPAIGN_MAP: CAMPAIGN_MAP,
    setCampaign: function (key) { _campaignConfig = (key && CAMPAIGN_MAP[key]) ? CAMPAIGN_MAP[key] : null; },
    getFixedDelivery: getFixedDelivery,
    initFixedWidget: initFixedWidget
  };

  // TEST CASES (manual verification):
  // new Date('2026-04-06T14:59:00Z') → Colombia lunes 09:59 → despacho martes 07 abr, ventana ABIERTA
  // new Date('2026-04-06T15:01:00Z') → Colombia lunes 10:01 → ventana cerrada, next: mié 08 abr
  // new Date('2026-04-11T17:00:00Z') → Colombia sábado 12:00 → next: mar 14 abr

}(typeof window !== 'undefined' ? window : (typeof global !== 'undefined' ? global : this)));
